export default __webpack_public_path__ + "static/location-weather-chart-bangkok-1517288718ccc0bde2d48cb086d2f00e.svg";